import { Phone } from "lucide-react";
import { COMPANY } from "@/data/content";

// Floating 24/7 emergency click-to-call banner (gold, high visibility)
export default function EmergencyBanner() {
  return (
    <a
      href={`tel:${COMPANY.phoneTel}`}
      data-testid="emergency-call-btn"
      className="fixed z-50 bottom-0 inset-x-0 md:bottom-6 md:right-6 md:left-auto md:inset-x-auto
                 flex items-center gap-4 bg-brand-gold text-brand-navy
                 px-5 py-4 md:px-6 md:py-4 md:rounded-2xl shadow-2xl shadow-brand-navy/20
                 hover:bg-brand-golddark transition-colors duration-300 group"
    >
      <span className="relative grid place-items-center w-11 h-11 rounded-full bg-brand-navy text-white animate-pulse-ring">
        <Phone className="w-5 h-5" />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.22em] font-semibold text-brand-navy/70">
          Urgence 24h/24 · 7j/7
        </span>
        <span className="font-display font-semibold text-lg tracking-tight">
          {COMPANY.phoneDisplay}
        </span>
      </span>
      <span className="hidden md:inline ml-2 text-xs uppercase tracking-wider font-semibold border-l border-brand-navy/25 pl-4 group-hover:translate-x-0.5 transition-transform duration-300">
        Appeler
      </span>
    </a>
  );
}
